Ext.define('SA.view.plugin.ViewportConstrainedAutoCenter', {
    alias: 'plugin.sa-viewport-constrained-auto-center',
    extend: 'Ext.AbstractPlugin',

    pluginId: 'sa-viewport-constrained-auto-center',

    init() {
        var cmp = this.cmp;

        cmp.constrain = true;

        cmp.on('show', this.center, this);
        SA.Viewport.on('resize', this.center, this, {buffer: 100});
    },

    center() {
        var cmp = this.cmp,
            body = Ext.getBody(),
            xy = cmp.getAlignToXY(body, 'c-c?');

        cmp.setPagePosition(xy);
    },

    destroy() {
        var cmp = this.cmp;

        cmp.un('show', this.center, this);
        SA.Viewport.un('resize', this.center, this);
    }
});
